import WebAPI from './WebAPI';
import config from '../../config';

const WebAPIClient = new WebAPI(config.adminGateway, 'v1');

export default WebAPIClient;
